import { render, staticRenderFns } from "./NewICD10.vue?vue&type=template&id=6ce7dbe8&scoped=true"
import script from "./NewICD10.vue?vue&type=script&lang=js"
export * from "./NewICD10.vue?vue&type=script&lang=js"
import style0 from "./NewICD10.vue?vue&type=style&index=0&id=6ce7dbe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce7dbe8",
  null
  
)

export default component.exports